/**
 * The breakpoints, mirrored from src/styles/breakpoints.css.
 *
 * A CSS custom property cannot appear inside a media-query condition, so the
 * values genuinely have to be written twice. `breakpoints.test.ts` parses the
 * stylesheet and asserts these match, which is the cheapest way to make the
 * duplication safe rather than merely acknowledged.
 */
export const BREAKPOINTS = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

/** Viewports the phone-width Playwright project and the unit tests use. */
export const VIEWPORTS = {
  /** iPhone SE — the narrowest screen we commit to. */
  phoneSmall: { width: 360, height: 780 },
  /** iPhone 15 — the design prototype's "Mobile · Stacked" frame is 393. */
  phone: { width: 390, height: 844 },
  tablet: { width: 768, height: 1024 },
  desktop: { width: 1280, height: 900 },
} as const
